import { render, staticRenderFns } from "./AddressCreateForm.vue?vue&type=template&id=ba4c5866"
import script from "./AddressCreateForm.vue?vue&type=script&lang=js"
export * from "./AddressCreateForm.vue?vue&type=script&lang=js"
import style0 from "./AddressCreateForm.vue?vue&type=style&index=0&id=ba4c5866&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports